/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIBillSearchResult } from './APIBillSearchResult';
import {
    APIBillSearchResultFromJSON,
    APIBillSearchResultFromJSONTyped,
    APIBillSearchResultToJSON,
} from './APIBillSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIBillSearchResponse
 */
export interface APIBillSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIBillSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIBillSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIBillSearchResult>}
     * @memberof APIBillSearchResponse
     */
    results: Array<APIBillSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIBillSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIBillSearchResponse interface.
 */
export function instanceOfAPIBillSearchResponse(value: object): value is APIBillSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIBillSearchResponseFromJSON(json: any): APIBillSearchResponse {
    return APIBillSearchResponseFromJSONTyped(json, false);
}

export function APIBillSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBillSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIBillSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIBillSearchResponseToJSON(value?: APIBillSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIBillSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

